import SuiviAgences from "./SuiviAgences";

/**
 * Dashboard « Suivi intermédiaires » — réutilise le composant Suivi agence, agrégé par
 * intermédiaire (entité Intermediaire).
 *
 * Drill-down actif (comme le suivi agence) : les cartes et KPI ouvrent les modales de listing
 * (endpoint dédié, rattachement par intermediaire_code_id) et « Détails » mène à la fiche
 * /intermediaire/:codeIntermediaire. Le bouton « Gérer » renvoie vers /intermediaires pour la
 * création/édition.
 */
const SuiviIntermediaires = () => (
    <SuiviAgences
        apiPath="/api/agence/suivi-intermediaires"
        refreshPath={null}
        pageTitle="Suivi des commerciaux"
        pageSubtitle="CA et commissions (dues, payées, reste) par commercial"
        entityLabel="commercial"
        intermediaireMode
        hideReversement
        manageLink="/intermediaires"
        autoTour={false}
    />
);

export default SuiviIntermediaires;
